<template>
  <v-flex id="impressum" class="xs12 pa-5 white-bg mt-5">
    <h1>Impressum</h1>
    <v-layout row wrap>
      <v-flex class="md4 pa-2">
        <v-flex class="xs12">
          <p>Entwicklung der Website: Nadin-Katrin Apel

            <a href="https://twitter.com/NadinApel" target="_blank" title="Visit me on twitter"><img
              src="../../assets/twitter.png" class="v-btn v-btn--flat v-btn--icon theme--light twitter-icon"
              alt="twitter icon"></a>
            <a href="https://www.linkedin.com/in/nadin-katrin-apel/" target="_blank" title="Visit me on linkedIn"
               style="margin-left: -21px;"><img src="../../assets/linkedin.png"
                                                class="v-btn v-btn--flat v-btn--icon theme--light twitter-icon"
                                                alt="linkedIn icon" style="    padding: 5px;"></a>
          </p>
        </v-flex>
        <v-flex class="xs12">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h2>Angaben gemäß § 5 TMG</h2><br>
                <h3 class="headline mb-0">TEC Waldau e.V. - Eis- und Rollkunstlaufabteilung</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <h4>Geschäftsstelle:</h4>
              <ul class="v-list">
                <li>Roland Hocker</li>
                <li>Minnesängerweg 68</li>
                <li>72131 Ofterdingen</li>
                <li></li>
              </ul>
              <h4 class="pt-3">Vertreten durch den Vorstand:</h4>
              <ul class="v-list">
                <li>Roland Hocker</li>
              </ul>
              <h4 class="pt-3">Kontakt:</h4>
              <ul class="v-list">
                <li>E-Mail: mail@tec-stuttgart.de</li>
              </ul>
              <h4 class="pt-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h4>
              <ul class="v-list">
                <li>Roland Hocker</li>
                <li>Minnesängerweg 68</li>
                <li>72131 Ofterdingen</li>
              </ul>
              <p class="pt-3">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.</p>

            </v-card-text>
          </v-card>

        </v-flex>
      </v-flex>

      <v-flex class="md8 pa-5">
        <h2>Haftung für Inhalte</h2>
        <v-flex xs12>
          <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
            forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
          <p>
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
            Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </v-flex>
        <h2>Haftung für Links</h2>
        <v-flex xs12>
          <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
            Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
            waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
          <p>
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
            Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
          </p>
        </v-flex>
        <h2>Urheberrecht</h2>
        <v-flex xs12>
          <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
          <p>
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
            Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
          <p>
            <v-btn @click="$emit('showDsgvo')" flat color="primary" class="ml-0 pl-0">↪️ Infos zu DSGVO ⚖️</v-btn><br></p>
          <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
        </v-flex>
      </v-flex>

  </v-layout>
  </v-flex>
</template>

<script>
  export default {
    name: 'my-footer',
    data() {
      return {
        imgFileTwitter: 'data:image/svg+xml;base64,PHN2ZyBpZD0iTG9nb19GSVhFRCIgZGF0YS1uYW1lPSJMb2dvIOKAlCBGSVhFRCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAwIDQwMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOiMxZGExZjI7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5Ud2l0dGVyX0xvZ29fQmx1ZTwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE1My42MiwzMDEuNTljOTQuMzQsMCwxNDUuOTQtNzguMTYsMTQ1Ljk0LTE0NS45NCwwLTIuMjIsMC00LjQzLS4xNS02LjYzQTEwNC4zNiwxMDQuMzYsMCwwLDAsMzI1LDEyMi40N2ExMDIuMzgsMTAyLjM4LDAsMCwxLTI5LjQ2LDguMDcsNTEuNDcsNTEuNDcsMCwwLDAsMjIuNTUtMjguMzcsMTAyLjc5LDEwMi43OSwwLDAsMS0zMi41NywxMi40NSw1MS4zNCw1MS4zNCwwLDAsMC04Ny40MSw0Ni43OEExNDUuNjIsMTQ1LjYyLDAsMCwxLDkyLjQsMTA3LjgxYTUxLjMzLDUxLjMzLDAsMCwwLDE1Ljg4LDY4LjQ3QTUwLjkxLDUwLjkxLDAsMCwxLDg1LDE2OS44NmMwLC4yMSwwLC40MywwLC42NWE1MS4zMSw1MS4zMSwwLDAsMCw0MS4xNSw1MC4yOCw1MS4yMSw1MS4yMSwwLDAsMS0yMy4xNi44OCw1MS4zNSw1MS4zNSwwLDAsMCw0Ny45MiwzNS42MiwxMDIuOTIsMTAyLjkyLDAsMCwxLTYzLjcsMjJBMTA0LjQxLDEwNC40MSwwLDAsMSw3NSwyNzguNTVhMTQ1LjIxLDE0NS4yMSwwLDAsMCw3OC42MiwyMyIvPjwvc3ZnPg=='
      }
    },
  }
</script>
<style>
  h4 {
    font-weight: 500;
  }

  #impressum {
    border-top: groove 4px #f9f9f9;
    box-shadow: 0px 9px 9px inset #52525287;
  }

  img.v-btn.v-btn--flat.v-btn--icon.theme--light.twitter-icon:hover {
    background: #00a0ed2b;
    padding: 1px;
    transition: background .5s;
    cursor: pointer;
  }

  img.v-btn.v-btn--flat.v-btn--icon.theme--light.linkedin-icon:hover {
    background: #00a0ed2b;
    padding: 1px;
    transition: background .5s;
    cursor: pointer;
  }

  @media (max-width: 900px) {
    #impressum > div > div.flex.md8.pa-5 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

  #impressum > div > div.flex.md8.pa-5 {
    line-height: 1.9;
    word-break: break-word;
    text-align: justify;
    margin-top: 5px;
  }
</style>
